import { fromUnixTime } from 'date-fns';

export default fromUnixTime;
